import axios from "axios";

const API = process.env.REACT_APP_API_URL;

export const getEstatesParents = async (params) => {
	const { data } = await axios.get(`${API}/admin/estates_parents`, {
		params,
	});
	return data;
};

export const getEstatesParent = async (params) => {
	const { data } = await axios.get(`${API}/admin/estates_parents/detail`, {
		params,
	});
	return data;
};

export const saveEstatesParent = async (params) => {
	const { data } = await axios.post(`${API}/admin/estates_parents/save`, params);
	return data;
};

export const deleteEstatesParent = async (params) => {
	const { data } = await axios.post(`${API}/admin/estates_parents/delete`, params);
	return data;
};
